export default [
  {
    question: "How do I earn rewards with SWTH?",
    answer: `Simply connect your wallet and stake your SWTH. The rewards are paid out on a per block basis. You can choose to withdraw your rewards back to your wallet or compound the rewards.`,
  },
  {
    question: "Where does the rewards come from?",
    answer:
      "Stakers earn inflationary SWTH from the network and trading fees on the Tradehub. The inflation will trend towards 7% if the staked ratio is more than 66%, and trend towards 20% if the staked ratio is less than 66%.",
  },
  {
    question: "Is there a lockup period?",
    answer:
      "There is a 28 days unbonding period when you want to unstake your SWTH from the network. During this period. you earn 0 rewards and will still be susceptible to slashing.",
  },
  {
    question: "Are there any risks involved with staking SWTH on Unagii?",
    answer: `Your SWTH will be staked to StakeWith.Us, a Singapore government backed staking infrastructure provider. There are slashing risks involved for downtime and double signing. Read about <a href="https://stakewith.us" target="_blank" rel="noopener noreferrer">StakeWith.Us</a>.`,
  },
  {
    question:
      "Where can I view governance proposals for Switcheo? How does voting work?",
    answer: `You can view governance proposals by clicking on the Governance tab. In the event you do not vote, your vote will follow the choices of your validator, which in this case, is StakeWith.Us.`,
  },
];
